import ConfirmPopover from '@/components/common/ConfirmPopover';
import IconButton from '@/components/common/IconButton';
import ClearIcon from '@mui/icons-material/Clear';
import EditIcon from '@mui/icons-material/Edit';
import { Box, ListItem, ListItemText } from '@mui/material';
import { FC, useState } from 'react';
import SyncEventListItemEdit from './SyncEventListItemEdit';
import { SyncEventItem } from './SyncEventsManager';

type SyncEventListItemProps = {
  syncEvent: SyncEventItem;
  onSave?: (newEventState: SyncEventItem) => void;
  onDelete?: () => void;
};

const SyncEventListItem: FC<SyncEventListItemProps> = (props) => {
  const [openEdit, setOpenEdit] = useState(props.syncEvent && !props.syncEvent.name);
  return (
    <ListItem sx={{ gap: 1, pt: 0, pb: 0 }}>
      {openEdit ? (
        <SyncEventListItemEdit
          syncEvent={props.syncEvent}
          onClose={(isEmpty) => {
            setOpenEdit(false);
            if (isEmpty) {
              props.onDelete && props.onDelete();
            }
          }}
          onSave={(newEventState) => {
            props.onSave && props.onSave(newEventState);
          }}
        />
      ) : (
        <>
          <ListItemText primary={props.syncEvent.name} />
          <code>{props.syncEvent.state}</code>
          <Box>
            <IconButton
              tooltip='Edit'
              onClick={() => {
                setOpenEdit(true);
              }}
            >
              <EditIcon />
            </IconButton>
            <ConfirmPopover
              text={
                <>
                  Delete <code>{props.syncEvent.name}</code>?
                </>
              }
              onConfirm={() => props.onDelete && props.onDelete()}
              skipConfirm={!props.syncEvent.name}
              icon={<ClearIcon />}
            />
          </Box>
        </>
      )}
    </ListItem>
  );
};

export default SyncEventListItem;
